/**
 * 为数据打标记
 */

/**
 * 标记是单向关系链的联系人
 * @param  {array} list 原始列表
 * @returns {array} 新的列表
 */
function oneWayRelationshipChainOfRecent(list, config) {
    list.forEach(originItem => {
        const item = originItem;
        if (item.metaSourceType === 'people' && item.userInfo) {
            /**
             * 说明： 仅适用最近联系人
             * friendship: 好友关系
             * 0:拉取失败;  1: 对方列表仅有该账号好友; 2: 该账号仅有对方好友; 3: 双方互为好友; 4:非好友
             * sessionType: 来源
             *   buddy: 好友; grouptmp: 群临时; discusstmp: 讨论组临时; crmtmp: 临时会话
             * 判断逻辑
             *  - 是单向好友
             *  - 且来源是好友
             * 新增逻辑 当没有任何关系的时候此时好友关系也不可选
             */
            if (
                // `${item.userInfo.friendship}` === '0' ||
                (`${item.userInfo.friendship}` === '1' || `${item.userInfo.friendship}` === '2') &&
                (item.userInfo.sessionType !== 'grouptmp' || item.userInfo.sessionType !== 'discusstmp')
            ) {
                item.oneWayRelationship = 1;
                if (config.disabled && config.disabled.indexOf('oneWayRelationshipChain') > -1) {
                    item.disabled = true;
                }
            } else if (`${item.userInfo.friendship}` === '4') {
                item.hidden = true;
            }
        }
    });
    return list.filter(item => !item.hidden );
}

function oneWayRelationshipChainOfQQFriend(list, oneWayUins, config) {
    const oneWayUnisOfSet = new Set(oneWayUins);
    console.log('oneWayRelationshipChainOfQQFriend', config);
    list.forEach(originItem => {
        const item = originItem;
        if (item.type === 'group') {
            item.groupList = oneWayRelationshipChainOfQQFriend(item.groupList, oneWayUins, config);
        } else if (oneWayUnisOfSet.has(originItem.id)) {
            item.oneWayRelationship = 1;
            if (config.disabled && config.disabled.indexOf('oneWayRelationshipChain') > -1) {
                item.disabled = true;
            }
        }
    });
    return list;
}

function oneWayRelationshipChain(list, datasourceType, config) {
    let newList = list || [];
    let oneWayUins = [];
    switch (datasourceType) {
        case 'recent':
            newList = oneWayRelationshipChainOfRecent(newList, config);
            break;
        case 'QQFriend':
            if (config && config.oneWayUins) {
                oneWayUins = config.oneWayUins;
            }
            newList = oneWayRelationshipChainOfQQFriend(newList, oneWayUins, config);
            break;
        default:
        // no code
    }

    return newList;
}

export default {
    oneWayRelationshipChain
};
